import { FC, useEffect } from "react";

const MetaNoFollow: FC = () => {
    useEffect(() => {
        const meta = document.createElement("meta");
        meta.name = "robots";
        meta.content = "nofollow";

        document.head.appendChild(meta);

        return () => {
            if (document.head.contains(meta)) {
                document.head.removeChild(meta);
            }
        };
    }, []);

    return null;
};

export default MetaNoFollow;
